import { XPRESSID_EVENTS_ORIGIN, XPRESSID_INFO_EVENTS, XPRESSID_INFO_EVENTS_TYPE } from '../constants';

export const processEventData = (event, onProcessCompleted, onProcessCancelled, onProcessError, onProcessEvents) => {
    const { origin, data } = event;
    if (!origin.includes(XPRESSID_EVENTS_ORIGIN)) return;
    const { type, code } = data;
    if (type === XPRESSID_INFO_EVENTS_TYPE) {
        const callbackByInfoEventCode = {
            [XPRESSID_INFO_EVENTS.ProcessCancelled]: onProcessCancelled,
            [XPRESSID_INFO_EVENTS.ProcessCompleted]: onProcessCompleted,
            [XPRESSID_INFO_EVENTS.ProcessEvents]: onProcessEvents,
        };

        return callbackByInfoEventCode[code]?.(data);
    }

    return onProcessError(data);
};
